import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/candyce-thomas")({
  beforeLoad: () => {
    throw redirect({ to: "/about", replace: true });
  },
});
